import { useState } from 'react';

import { faSlidersSimple } from '@awesome.me/kit-f3dc60f0d0/icons/classic/regular';
import { faArrowDownRight } from '@awesome.me/kit-f3dc60f0d0/icons/duotone/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/react/macro';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@repo/videa-components/src/index';
import { useAtom } from 'jotai';

import { disableDragAtom } from '../findingSidebar/confidenceScoreFilter/atoms';
import { ConfidenceScoreFilterV2 } from '../findingSidebar/confidenceScoreFilter/ConfidenceScoreFilterV2';

import { ToolbarButton } from './ToolbarButton';

export const DisplayThresholdToggle = () => {
  const [, setDisableDrag] = useAtom(disableDragAtom);
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenChange = (open: boolean) => {
    setDisableDrag(open);
    setIsOpen(open);
  };

  return (
    <Popover open={isOpen} onOpenChange={handleOpenChange}>
      <Tooltip>
        <TooltipTrigger asChild>
          <PopoverTrigger asChild>
            <div className="vai-relative">
              <ToolbarButton
                dataTestId="display-threshold-toggle"
                isActive={isOpen}
              >
                <FontAwesomeIcon
                  icon={faSlidersSimple}
                  className="vai-text-slate-200 max-[880px]:vai-text-lg min-[880px]:vai-text-xl"
                />
                <FontAwesomeIcon
                  icon={faArrowDownRight}
                  className="vai-text-slate-300 vai-absolute max-[880px]:vai-right-[-2px] max-[880px]:vai-bottom-[-2px] min-[880px]:vai-right-[-3px] min-[880px]:vai-bottom-[-3px] max-[880px]:!vai-size-1.5 min-[880px]:!vai-size-2.5 [--fa-secondary-opacity:0]"
                />
              </ToolbarButton>
            </div>
          </PopoverTrigger>
        </TooltipTrigger>
        <TooltipContent
          variant="dark"
          side="right"
          sideOffset={8}
          alignOffset={-4}
        >
          <p>
            <Trans>Display Threshold</Trans>
          </p>
        </TooltipContent>
      </Tooltip>
      <PopoverContent
        side="right"
        sideOffset={8}
        className="!vai-bg-[#393E4D] !vai-border-none !vai-w-fit !vai-flex vai-gap-1 !vai-p-1 !vai-m-0"
      >
        <ConfidenceScoreFilterV2 image={null} />
      </PopoverContent>
    </Popover>
  );
};
